export default __webpack_public_path__ + "static/media/commingsoon.519fffa2.png";